import React from 'react'
import { Icon, latLng, Marker, Popup, useMap } from '@fareye/ui'
// import { Exception } from '../../utils/types'
import ExceptionInfoWindow from '../Map/ExceptionInfoWindow'

interface ExceptionMarkerProps {
  exception: any
  iconUrl?: string
  iconSize?: [number, number]
  selected?: boolean
  type?: string
}

export function ExceptionMarker({
  iconUrl,
  iconSize,
  exception,
  selected,
  type = ''
}: any) {
  const [fakeState, setFakeState] = React.useState(0)
  const map = useMap()
  let ref = React.useRef(null)

  React.useEffect(() => {
    if (selected && ref) {
      map.openPopup(ref.current as any)
      setFakeState(fakeState + 1)
    }
  }, [selected])
  if (selected){
    map.setView(latLng(exception.coords.lat, exception.coords.lng), 13)
    map.setView(latLng(exception.coords.lat, exception.coords.lng), 12)
  }
  return (
    <Marker
      position={latLng(
        Number(exception.coords.lat),
        Number(exception.coords.lng)
      )}
      icon={
        new Icon({
          iconUrl: iconUrl || 'https://i.imgur.com/zsdfAMX.png',
          iconSize: iconSize || [15, 15],
          iconAnchor: [7, 15]
        })
      }
      eventHandlers={{
        click: () => setFakeState(fakeState + 1)
      }}
      // ref={el => openPopup(el)}
    >
      <Popup minWidth={149} ref={ref}>
        <ExceptionInfoWindow exception={exception} type={type} />
      </Popup>
    </Marker>
  )
}
